import { Action, createReducer, on } from "@ngrx/store";
import {ChatActions} from "./chatActions";
import {chatAdapter, initialChatState, messageAdapter, participantAdapter} from "./chat.state";

export const chatReducer = createReducer(
    initialChatState,
    on(ChatActions.foundChat, (state, { chat }) => {
        return {
            ...state,
            chats: chatAdapter.addOne(chat, state.chats)
        }
    }),
    on(ChatActions.foundMultipleChats, (state, { chats }) => {
        return {
            ...state,
            chats: chatAdapter.setAll(chats, state.chats)
        }
    }),
    on(ChatActions.foundParticipants, (state, { participants }) => {
        return {
            ...state,
            participants: participantAdapter.addMany(participants, state.participants)
        }
    }),
    on(ChatActions.foundParticipant, (state, { participant }) => {
        return {
            ...state,
            participants: participantAdapter.setOne(participant, state.participants)
        }
    }),
    on(ChatActions.foundMessage, (state, { message }) => {
        return {
            ...state,
            messages: messageAdapter.addOne(message, state.messages)
        }
    }),
    on(ChatActions.foundMultipleMessages, (state, { messages }) => {
        return {
            ...state,
            messages: messageAdapter.setAll(messages, state.messages)
        }
    }),
);
